import React, { useState } from 'react';

import Column from 'components/common/Column';
import Text from 'components/common/Text';
import ModalContainer from 'containers/ProductRegist/components/common/ModalContainer';
import HostEmailInput from './HostEmailInput';
import { EMAIL_REGEX } from 'utils/regExp';
import { useCheckExistEmail } from '../hooks/useCheckExistEmail';

interface HostEmailModalIProps {
  onClose: () => void;
  onSubmit: (email: string) => void;
}

const HostEmailModal: React.FC<HostEmailModalIProps> = props => {
  const { onClose, onSubmit } = props;

  const [email, setEmail] = useState<string>('');
  const { existEmail, handleCheckExistEmail } = useCheckExistEmail();
  const isExistEmail = existEmail === email;

  return (
    <ModalContainer
      isAbled={EMAIL_REGEX.test(email) && !isExistEmail}
      isMobile={false}
      onClose={onClose}
      onClick={async () => {
        if (!EMAIL_REGEX.test(email) || isExistEmail) {
          return;
        }

        if (!(await handleCheckExistEmail(email))) {
          onSubmit(email);
        }
      }}
      onCloseText="취소"
      onAcceptText="가입하기"
      style={{ maxWidth: '375px' }}
    >
      <Column gap="24px" style={{ padding: '24px 20px 0 20px' }}>
        <Column gap="8px" align="flex-start">
          <Text color="#1b1c1e" size="20px" weight={600}>
            이메일 입력이 필요해요
          </Text>
          <Text color="#70737c" size="14px" weight={400}>
            소셜 계정에서 이메일 정보를 가져오지 못했어요.
          </Text>
        </Column>
        <HostEmailInput
          email={email}
          isExistEmail={isExistEmail}
          handleCheckExistEmail={handleCheckExistEmail}
          handleChangeSignupParam={(_, value) => setEmail(value)}
        />
      </Column>
    </ModalContainer>
  );
};

export default HostEmailModal;
